import { render } from "./FormTextarea.vue?vue&type=template&id=1f6b1b7a&ts=true"
import script from "./FormTextarea.vue?vue&type=script&lang=ts"
export * from "./FormTextarea.vue?vue&type=script&lang=ts"

import exportComponent from "/builds/descript/vue-js-teq-application/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__